'use strict';/* global define */define('modules/download/constants/feedback-period-durations/index',['require','exports','module'],function(require,exports,module){'use strict';module.exports=['P3M','P6M','P1Y','P2Y','ALL'];});
